var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.address.google)?_c('span',[(_vm.loaded)?[_c('div',[_c('span',[_vm._v("\n        "+_vm._s(_vm.distance)+",\n        "+_vm._s(_vm.duration)+"\n      ")])])]:[_c('font-awesome-icon',{attrs:{"icon":['fal', 'spinner'],"spin":""}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }